import React from 'react';

import { SearchConfigure } from '@uncinc/react-searchkit';
import { SearchVacancies } from '../../../components';


const ParagraphInternshipVacanciesOverview = ({entity}) => {

  const searchParameters = {
  filters: `field_employment_type_name:Internship`,
  };

  return (
    <div className="Paragraph ParagraphInternshipVacanciesOverview">
      <SearchVacancies>
      <SearchConfigure
        {...searchParameters}
      />

        <div className="row justify-content-center">
        {/* <h2>{entity.getIn(['field_title', 0, 'value'])}</h2> */}
          <div className="col-12 offset-lg-1 col-lg-8">
          <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
            <SearchVacancies.Results />
          </div>
        </div>
      </SearchVacancies>
    </div>
  );
};

export default ParagraphInternshipVacanciesOverview;
